import React from 'react'
import {
  Building2,
  Layers,
  ShieldCheck,
  Calendar,
  ShieldQuestion,
} from 'lucide-react'
import { useAppTheme, Text } from '@workwhile/ui'
import { AccordionCard } from 'components/AccordionCard'
import { FlexibleInfoTable } from './FlexibleInfoTable'
import { useRequirementDetailContextValue } from '../context/RequirementDetailProvider'
import { format } from 'date-fns'

export const GeneralDetails = () => {
  const { space } = useAppTheme()
  const {
    state: { category, company, verificationType, createdAt, updatedAt },
  } = useRequirementDetailContextValue()

  return (
    <AccordionCard
      title="General details"
      size="small"
      contentWrapperProps={{
        display: 'flex',
        flexDirection: 'column',
        gap: space[2],
      }}
    >
      <FlexibleInfoTable Icon={Building2}>
        <Text fontSize={2}>
          {company ? `${company.name} (${company.id})` : 'Global'}
        </Text>
      </FlexibleInfoTable>
      <FlexibleInfoTable Icon={ShieldCheck}>
        <Text fontSize={2}>Verification type: {verificationType}</Text>
      </FlexibleInfoTable>
      <FlexibleInfoTable Icon={Layers}>
        <Text fontSize={2}>Category: {category}</Text>
      </FlexibleInfoTable>
      <FlexibleInfoTable Icon={Calendar}>
        <Text fontSize={2}>Created at: {format(createdAt, 'MM/dd/yyyy')}</Text>
        <Text fontSize={2}>Updated at: {format(updatedAt, 'MM/dd/yyyy')}</Text>
      </FlexibleInfoTable>
      <FlexibleInfoTable Icon={ShieldQuestion}>
        <Text fontSize={2}>
          Verification type: {verificationType ?? 'none'}
        </Text>
      </FlexibleInfoTable>
    </AccordionCard>
  )
}
